import React from 'react'

function Universe() {
    return (
        <div className='container mt-5 pt-5 text-center'>
            <h2 className='text-center text-muted pb-3'>The StocXpert Universe</h2>
            <div className='row mt-5 '>
                <div className='col-1'></div>
                <div className='col-md-3 text-center text-muted ms-4'>
                    <img src='media/images/sensibullLogo.svg' alt='
                    nithin' className=' mb-3' style={{ width: "60%" }}></img>
                    {/* <div className='ms-4 ps-2  mt-2'> */}
                    {/* <h6 className='fs-5 '>Sahil Yadav</h6> */}
                    <p className='fs-6'>Our asset management venture
                        that is creating simple and transparent index
                        funds to help you save for your goals.
                    </p>
                    {/* </div> */}
                </div>
                <div className='col-md-3 text-center text-muted ms-4'>
                    <img src='media/images/dittoLogo.png' alt='
                    nithin' className=' mb-3' style={{ width: "30%" }}></img>
                    {/* <div className='ms-4 ps-2  mt-2'> */}
                    {/* <h6 className='fs-5 '>Sahil Yadav</h6> */}
                    <p className='fs-6'>Options trading platform that lets you
                        create strategies, analyze positions, and examine
                        data points like open interest, FII/DII, and more.
                    </p>
                    {/* </div> */}
                </div>
                <div className='col-md-3 text-center text-muted ms-4'>
                    <img src='media/images/smallcaseLogo.png' alt='
                    nithin' className=' mb-3' style={{ width: "60%" }}></img>
                    {/* <div className='ms-4 ps-2  mt-2'> */}
                    {/* <h6 className='fs-5 '>Sahil Yadav</h6> */}
                    <p className='fs-6'>
                        Thematic investing platform
                        that helps you invest in diversified
                        baskets of stocks on ETFs.</p>
                    {/* </div> */}
                </div>
                <div className='col-1'></div>
            </div>
            <div className='row mt-5 '>
                <div className='col-1'></div>
                <div className='col-md-3 text-center text-muted ms-4'>
                    <img src='media/images/sensibullLogo.svg' alt='
                    nithin' className=' mb-3' style={{ width: "60%" }}></img>
                    {/* <div className='ms-4 ps-2  mt-2'> */}
                    {/* <h6 className='fs-5 '>Sahil Yadav</h6> */}
                    <p className='fs-6'>Our asset management venture
                        that is creating simple and transparent index
                        funds to help you save for your goals.
                    </p>
                    {/* </div> */}
                </div>
                <div className='col-md-3 text-center text-muted ms-4'>
                    <img src='media/images/streakLogo.png' alt='
                    nithin' className=' mb-3' style={{ width: "30%" }}></img>
                    {/* <div className='ms-4 ps-2  mt-2'> */}
                    {/* <h6 className='fs-5 '>Sahil Yadav</h6> */}
                    <p className='fs-6'>Options trading platform that lets you
                        create strategies, analyze positions, and examine
                        data points like open interest, FII/DII, and more.
                    </p>
                    {/* </div> */}
                </div>
                <div className='col-md-3 text-center text-muted ms-4 pb-3 mb-3'>
                    <img src='media/images/smallcaseLogo.png' alt='
                    nithin' className=' mb-3' style={{ width: "60%" }}></img>
                    {/* <div className='ms-4 ps-2  mt-2'> */}
                    {/* <h6 className='fs-5 '>Sahil Yadav</h6> */}
                    <p className='fs-6'>
                        Thematic investing platform
                        that helps you invest in diversified
                        baskets of stocks on ETFs.</p>
                    {/* </div> */}
                </div>
                <div className='col-1'></div>
            </div>
            <button className='p-1 btn btn-primary fs-4 mb-5 mt-3 text-center' style={{width:"18%", margin:"0 auto "}}>
                Signup for free
            </button>
        </div>
    );
}

export default Universe;